import { render, staticRenderFns } from "./OrdersErrors.vue?vue&type=template&id=4fbd4ae1&"
import script from "./OrdersErrors.vue?vue&type=script&lang=js&"
export * from "./OrdersErrors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports